<template>
    <div class="empty-list">
        <img v-if="showImage" class="m-b-16" src="@/assets/images/empty.png" />
        <p class="message" v-html="message" />
    </div>
</template>

<script>
export default {
    name: 'EmptyList',
    props: {
        message: {
            type: String,
            required: true,
        },
        showImage: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.empty-list {
    display: flex;
    //flex-direction: column;
    align-items: center;

    .message {
        margin: 0;
        color: $grey-09;
    }
}
</style>
